/**
 * skypt odpowiedzialny za właściwe zarządzanie fotkami z lazy
 */

console.log('LOADED: images');

import LazyLoad from 'vanilla-lazyload';

$(document).ready(function() {
	new LazyLoad({
		elements_selector: '.lazy',
	});
});
